// after home page 

import React, { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "./Navbar";
import coin from '../assets/earn-coin.svg';
import Lottie from "lottie-react";
import trophy from '../assets/Trophy.json';
import Adsense from './Adsense';

function Start() {

      const { name } = useParams();
       const navigate = useNavigate();
       const location = useLocation();

const score = location.state?.score || 0;
  return (
    <>
     <div className="main">
        <div className="main-div2">
          <div className="container mt-3">
            {/* <div className="">
              <Navbar />
            </div> */}
                {/* <div className="mt-2">
               <Adsense slot="6300978111"/>
              </div> */}
            <div className="card p-4 text-center mt-4 mb-4">
                 <div>
      <Lottie
        animationData={trophy}
        loop={true}
        style={{ width: 250 ,margin:"20px auto" }}
      />
    </div>
              {/* 🔥 Ahiya dynamic category name */}
              {/* <h5 >{name.toUpperCase()}</h5> */}

              <h4>You have got {score} coins!</h4>

              <button className="play-btn  mt-3"   onClick={() =>  navigate("/category")}>Play Now</button>

              {/* <p className="mt-2">Or</p> */}

              {/* <button className="btn btn-warning">Play as Guest</button> */}
              
            </div>
            <div className='mt-5 '>
                <h4 className='text-center'>Play Quiz and Win Coins!</h4>

              <ul className="text-start mt-3 mb-5  d-flex flex-column gap-2">
                <li>Play Quizzes in 10+ categories like GK, Bollywood, Business, Cricket & more!</li>
                <li>Compete with lakhs of other players!</li>
                <li>Win coins for every game</li>
                <li>Trusted by millions of other quiz enthusiasts like YOU!</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Start
